import React, { Component} from 'react';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline";

// utils
import { isCountryCounter, isMobile } from "../../../utils";

// counts
import { LIVE_MUSIC, BAND, MUSICIAN, SERVICE } from "../../../consts";

// styles
import './PinCounterAnimated.css';
import { RandomIcons } from "../Decorations";

// icons
import smallStarSVG from "../../inlineSVGs/smallStarSVG";
import mugicsSideLookGuitarSVG from "../../inlineSVGs/mugicsSideLookGuitarSVG";
import mugicsYellowPianoSVG from "../../inlineSVGs/mugicsYellowPianoSVG";
import mugicsGlassesGuitarSVG from "../../inlineSVGs/mugicsGlassesGuitarSVG";
import mugicsPartySVG from "../../inlineSVGs/mugicsPartySVG";

const ANIMATION_INC_TIME = 2000; // ms
const ANIMATION_STEP_DELAY = 20 // ms

class PinCounterAnimated extends Component {
    constructor(props) {
        super(props);

        this.state = {
            countryPinCount: 0
        }
    }

    componentDidMount() {
        if (
            this.props.startCountAnimation &&
            this.props.countryPinCount &&
            this.props.countryPinCount.country &&
            this.state.countryPinCount === 0
        ) {
            const countStep = Math.ceil((this.props.countryPinCount.pinCount * ANIMATION_STEP_DELAY) / ANIMATION_INC_TIME) || 1
            this.recursiveCountInc(countStep);
        }
    }

    // TODO: improve rel count vs count speed
    componentDidUpdate(prevProps) {
        let countStep = 2;

        if (!prevProps.startCountAnimation && this.props.startCountAnimation) {
            countStep = Math.ceil((this.props.countryPinCount.pinCount * ANIMATION_STEP_DELAY) / ANIMATION_INC_TIME) || 1
            this.recursiveCountInc(countStep);
            return;
        }

        if (prevProps.countryPinCount && this.props.countryPinCount) {
            if (
                prevProps.countryPinCount.country !== this.props.countryPinCount.country ||
                prevProps.countryPinCount.pinCount !== this.props.countryPinCount.pinCount
            ) {

               this.setState({ countryPinCount: 0}, () => {
                   countStep = Math.ceil((this.props.countryPinCount.pinCount * ANIMATION_STEP_DELAY) / ANIMATION_INC_TIME) || 1
                   this.recursiveCountInc(countStep);
                });
            }
        }
    }

    recursiveCountInc(countStep) {
        if (
            this.props.countryPinCount &&
            this.props.countryPinCount.pinCount &&
            this.state.countryPinCount < this.props.countryPinCount.pinCount
        ) {
            // prevent counter making last step leap.
            if (this.props.countryPinCount.pinCount <= this.state.countryPinCount + countStep) {
                return this.setState({ countryPinCount: this.props.countryPinCount.pinCount})
            }

            this.setState({ countryPinCount: this.state.countryPinCount + countStep });
            setTimeout(() => {
                this.recursiveCountInc(countStep)
            }, ANIMATION_STEP_DELAY)
        }
    }

    getText(type) {
        let text = 'Live events';
        if (type === SERVICE) text = 'Music services'
        if (type === BAND) text = 'Bands'
        if (type === MUSICIAN) text = 'Musicians'

        return text
    }

    // Live shows & Music events
    // Music services & Business
    // Bands looking for a new musician
    // Musicians looking for a new band
    renderNoCountBar() {
        let typeText = 'הופעות חיות ואירועי מוזיקה';
        switch (this.props.type) {
            case SERVICE:
                typeText = 'שירותי מוזיקה ועסקים';
                break;
            case BAND:
                typeText = 'להקות שמחפשות מוזיקאי חדש';
                break;
            case MUSICIAN:
                typeText = 'מוזיקאים שמחפשים להקה חדשה';
                break;
            default:
        }

        return <div className={`web-map-bar ${this.props.type}`}>{typeText}</div>
    }

    render() {
        const { countryPinCount, defaults, type } = this.props;

        if (!countryPinCount || !isCountryCounter(type, defaults, countryPinCount.pinCount)) {
            return !isMobile() ? this.renderNoCountBar() : null;
        }

        const { country } = countryPinCount || {};

        let strArr = ['0','0','0','0'];
        if (this.state.countryPinCount) {
            strArr = this.state.countryPinCount.toString().split('') || [];
        }

        let counterText = 'שירותי מוזיקה ועסקים' // 'Music services & Business';
        let typeIcon = mugicsPartySVG;

        if (type === LIVE_MUSIC) {
            counterText = ` הופעות חיות ${this.props.chosenDateLabel.toLowerCase()}`;
            typeIcon = mugicsGlassesGuitarSVG;
        }

        if (type === BAND) {
            counterText = 'להקות שמחפשות מוזיקאי חדש' //'Bands looking for musicians';
            typeIcon = mugicsYellowPianoSVG;
        }

        if (type === MUSICIAN) {
            counterText = 'מוזיקאים שמחפשים להקה חדשה' // 'Musicians looking for a new band'
            typeIcon = mugicsSideLookGuitarSVG;
        }

        return (
            <div className={`pin-counter-animated-wrapper ${type}`}>
                <span className="country-title">{country === 'Israel'  ? 'ישראל' : country}</span>
                <span className={`counter-wrapper ${type}`}>
                   <div className="digit-box">{strArr[strArr.length - 5] || '0'}</div>
                   <div className="digit-box">{strArr[strArr.length - 4] || '0'}</div>
                   <div className="digit-box">{strArr[strArr.length - 3] || '0'}</div>
                   <div className="digit-box">{strArr[strArr.length - 2] || '0'}</div>
                   <div className="digit-box">{strArr[strArr.length - 1] || '0'}</div>
                </span>
                <span className="counter-text">{counterText}</span>
                <RandomIcons
                    customClass="rand-icons-wrapper"
                    key={'web-1'}
                    iconSVG={smallStarSVG}
                    numIcons={50}
                />

                {isMobile() ? <SVGInline component="i" svg={typeIcon} width="85px" className="mugics-type-icon"/> : null}

            </div>
        )

    }
}

PinCounterAnimated.propTypes = {
    type: PropTypes.oneOf([LIVE_MUSIC, SERVICE, BAND, MUSICIAN]),
    defaults: PropTypes.object,
    countryPinCount: PropTypes.object,
    chosenDateLabel: PropTypes.string,
    startCountAnimation: PropTypes.bool
}

export default PinCounterAnimated;



// WEBPACK FOOTER //
// ./src/Components/Elements/PinCounters/PinCounterAnimated.js